import { useAppSelector } from "@/store/hooks";
import { HiOutlinePhotograph } from "react-icons/hi";
import { EditorContainer } from "../../EditorContainer";
import { ImageExtractButton, WordGrammarLimitForm } from "./WordGrammarLimitForm";

export function GrammarFormEditor() {
  const { slide } = useAppSelector((state) => state.slideEditor.present);

  return (
    <EditorContainer>
      {/* Header */}
      <div className="flex items-center justify-between shrink-0 px-3 gap-2">
        <h2 className="flex-1 min-w-0 text-sm font-semibold text-primary-900 truncate uppercase tracking-widest">
          {slide?.name || "AI Conversation"}
        </h2>
        <span className="text-[10px] font-medium text-gray-100 bg-primary-900 px-2 py-0.5 rounded-full shrink-0">
          AI Conversation
        </span>
      </div>

      {/* LIMITATION FORM */}
      <div className="flex-1 overflow-y-auto flex flex-col gap-3 py-2">
        <div className="flex items-center gap-2 mx-2 px-3 py-2 bg-gray-50 rounded-lg border border-gray-200">
          <HiOutlinePhotograph className="w-4 h-4 text-gray-400 shrink-0" />
          <span className="flex-1 min-w-0 text-xs text-gray-500">
            Have a textbook page? Upload it to fill both sections below.
          </span>
          <ImageExtractButton />
        </div>
        <WordGrammarLimitForm type="word" />
        <WordGrammarLimitForm type="grammar" />
      </div>
    </EditorContainer>
  );
}
